import { AdminRole, MerchantRole } from 'src/app/shared/enums/roles';

export interface IUserProfile {
  _id: string;
  image: string | null;
  isInitMerchant: boolean;
  name: string;
  email: string;
  roles: AdminRole | MerchantRole;
  phoneNumber?: number;
  lineConnected?: boolean;
  lineDisplayName?: string;
  merchant?: IMerchantInfo;
}

export interface IMerchantInfo {
  _id: string;
  latitude: number;
  longitude: number;
  merchantName: string;
  merchantDescription?: string;
  sportType: string[];
  accountBank: string;
  accountName: string;
  accountNo: string;
  merchantColor: string;
  merchantMapUrl: string;
  isPrivate: boolean;
  commissionRate: number;
  phoneNumber: string;
  lineId: string;
  merchantEmail: string;
  facebook: string;
  ig: string;
  tiktok: string;
}

export interface IUserFeatureState {
  profile: IUserProfile | null;
  isSuccess: boolean;
  error: string | null;
}

export const userFeatureKey = 'user';
